// extracted by mini-css-extract-plugin
module.exports = {"overflow":"styles-module__overflow___wLmnL","overflowitem":"styles-module__overflowitem___s-6KC"};